export const SET_SCHEDULE = 'SET_SCHEDULE'
export const SET_IS_OPTIMIZING = 'SET_IS_OPTIMIZING'
export const SET_IS_SAVING = 'SET_IS_SAVING'
export const SET_IS_READY_TO_BE_SAVED = 'SET_IS_READY_TO_BE_SAVED'
export const SET_OPTIMIZED_DROPS = 'SET_OPTIMIZED_DROPS'
export const SET_RESET_STATE = 'SET_RESET_STATE'
